"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ConnectionType {
    constructor(response) {
        this.connectionType = response.connection_type;
        this.ipAddress = response.ip_address;
    }
}
exports.default = ConnectionType;
